import type { StorefrontBundle } from '@/features/storefront/api/storefront';

/**
 * What a "frequently bought together" bundle takes off a set worth `base`,
 * the way the cart prices one complete set.
 *
 * A preview only: the cart recomputes it from its own lines, so the page can
 * never promise a figure the till will not honour. The part applies it only
 * while every item is ticked - a partial set gets no bundle discount in the
 * cart either.
 */
export function bundleSaving(
  bundle: Pick<StorefrontBundle, 'discount_type' | 'discount_value'>,
  base: number,
): number {
  const value = Number(bundle.discount_value) || 0;
  if (base <= 0 || value <= 0) return 0;
  if (bundle.discount_type === 'percent') return Math.min(base, Math.round(base * value) / 100);
  if (bundle.discount_type === 'fixed') return Math.min(base, value);
  return 0;
}
